import store from '../../../store'
import moment from 'moment'
import 'moment/locale/zh-cn'

const state = store.state
const req_url = state.req_url
const img_req_url = state.img_req_url

const filter = {
  deal(p, dir, w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用哪一个字典
    if (state[dir] == '') {
      return a
    }
    let i = state[dir].findIndex((item) => item.id == p)
    if (p + '' &&  i!= -1) {
      return state[dir][i][w]
    } else {
      return a
    }
  },
  dealName(p, dir, f = 'id', w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用数组
    if(dir && dir.length > 0) {
      let index = dir.findIndex((b) => b[f] == p)
      if(index > -1) {
        return dir[index][w]
      }else {
        return a
      }
    }else {
      return a
    }
  },
  dealNeed(p, dir, w = 'name', a = '--') { // 基本过滤,w表示返回字段,dir表示用哪一个字典(按需加载时使用)
    let i = dir.findIndex((item) => item.id == p)
    if (p + '' &&  i!= -1) {
      return dir[i][w]
    } else {
      return a
    }
  },
  dealArrayName(arr, dir, f = 'id', w = 'name', a = '--') {
    if(arr.length && dir.length) {
      let str = arr.map((a) => {
        let index = dir.findIndex((b) => b[f] == a)
        if(index > -1) {
          return dir[index][w]
        }else {
          return a
        }
      })
      return str.join('、')
    } else {
      return a
    }
  },
  timeToMonth(p) { // 只取月份
    let temp = p.split('-')
    if (parseInt(temp[1]) > 9) {
      return temp[1]
    } else {
      return temp[1].split('')[1]
    }
  },
  timeToYear(p) { // 只取年份
    let temp = p.split('-')
    return temp[0]
  },
  timeTrans(p, a = '--') { // 时间过滤(精确到日)
    if(p) {
      if (p.indexOf('T') != -1) {
        return p.split('T')[0]
      }
      if (p.indexOf(' ') != -1) {
        return p.split(' ')[0]
      }
    } else {
      return a
    }
  },
  time_moment(t, f = 'YYYY-MM-DD') { // 用moment处理时间
    return moment(t).format(f)
  },
  time_moment_second(t, f = 'YYYY-MM-DD HH:mm') {
    if(t) {
      let time = moment(t)
      return moment(time).format(f)
    }else {
      return ''
    }
  },
  time_moment_hour(t, f = 'HH:mm') {
    let time = moment(t)
    if(time) {
      return moment(time).format(f)
    }else {
      return '--'
    }
  },
  time_standard(t) { // 用moment处理时间
    let time = moment(t)
    let now = moment()
    let du = moment.duration(now - time)._milliseconds
    if(du < 259200000) { // 三天
      return moment(t).fromNow()
    } else {
      return moment(t).format('YYYY-MM-DD')
    }
  },
  time_standard_temp(t) { // 用moment处理时间(用于tempTimeLine)
    let time = moment(t)
    let now = moment()
    let du = moment.duration(now - time)._milliseconds
    if(du < 259200000) { // 三天
      console.log(moment(t).fromNow())
      return moment(t).fromNow().split(' ').join('')
    } else {
      return moment(t).format('HH:mm')
    }
  },
  logo_show(path) { // 图片
    if (path && path != '--') {
      return img_req_url + path
    } else {
      return require('../../pic/default-logo.png')
    }
  },
  dealTitle(p) {
    if (!p) {
      return ''
    }
    let rep = new RegExp('&amp;','g')
    return p.replace(rep, '&')
  },
  numberFormatter(num) { //数字格式化
    if(num >= 0 && num < 10) {
      return '0' + num
    }else {
      return num
    }
  },
  changeBase64(txt) {
    return window.btoa(txt)
  },
  empty(v, x='--') { // 剔除空值的情况, x为想要显示的控制的参数
    return v ? v : x
  },
  numberMax(num) {
    if(num < 1000) {
      return num
    }else {
      return '999+'
    }
  },
  addressPeggingPrintf(id, address = [], delimit="/", text = '--') { // 地址反查+打印
    let arr = []
    if (id) {
      let position = address.find(item => item.id == id) || {}
      if (position.pid == null && position.gpid == null) {
        arr = [id]
      } else if(position.pid != null && position.gpid == null) {
        arr = [position.pid, id]
      } else {
        arr = [position.gpid, position.pid, id]
      }
    }
    if (arr.length != 0) {
      let temp = []
      for(let i of arr) { // 需要注意的是循环顺序不一定是按照构建顺序
        let s = filter.dealNeed(i, address)
        if (s != '--') {
          temp.push(s)
        }
      }
      return temp.join(delimit)
    } else {
      return text
    }
  },
  tct_time_list(y, t) {
    if (t == 0 || t == 2) {
      return y
    } else if (t == 1) {
      let y1 = y.split('Q')[0],
          y2 = y.split('Q')[1]
      if (y2 == 1) {
        return y1 + '.Q' + y2
      } else {
        return 'Q' + y2
      }
    }
  },
  getPgidName(id, dir) {
    let index = dir.findIndex(a => a.id == id)
    if (index > -1) {
      if (dir[index].pid != null && dir[index].gpid != null) {
        let index_p = dir.findIndex(a => a.id == dir[index].gpid)
        return dir[index_p].name
      }
      if (dir[index].pid != null && dir[index].gpid == null) {
        let index_p = dir.findIndex(a => a.id == dir[index].pid)
        return dir[index_p].name
      }
    }
  },
  getPidName(id, dir) {
    let index = dir.findIndex(a => a.id == id)
    if (index > -1) {
      if (dir[index].pid != null && dir[index].gpid != null) {
        let index_p = dir.findIndex(a => a.id == dir[index].pid)
        return dir[index_p].name
      }
      if (dir[index].pid != null && dir[index].gpid == null) {
        let index_p = dir.findIndex(a => a.id == dir[index].id)
        return dir[index_p].name
      }
    }
  }
}

export default filter
